import { DebugService } from './debug.service.js';

export class _FeatureToggleService {
  constructor() {
    this._featureToggles = [];
    this.debug = new DebugService('FeatureToggleService');
  }

  setFeatureToggles(featureToggles) {
    this._featureToggles = featureToggles;
  }

  featureEnabled(featureToggleKey) {
    return this._featureToggles?.find(featureToggle => featureToggle.featureKey === featureToggleKey)?.isEnabled || false;
  }
}

export const FeatureToggleService = new _FeatureToggleService();
